module.exports = __webpack_public_path__ + "static/media/star.f27441a7.svg";